/* eslint-disable class-methods-use-this */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { connect, Provider } from 'react-redux';
import DropdownMenu from '@dc/ui-library/src/organisms/DropdownMenu/DropdownMenu';
import HeaderComponent from '@dc/ui-library/src/organisms/Header/Header';
import {
  settings, menuLinks,
  translations, replacePlaceholders
} from '@dc/ui-library/src/config';
import { autocompleteFactory, saytFactory } from '@dc/ui-library/src/helpers/searchApi';
import { resolveByCountry } from '@dc/ui-library/src/helpers/environment';
import { removeFromSessionStorage } from '@dc/ui-library/src/helpers/sessionStorage';
import { setCartItemsCount } from '../../../appState/ducks/general';
import constants from '../constants';

let autocomplete;
let sayt;

const mapAutocompleteResults = (items) => items.map((item) => ({
  title: item,
  type: 'autocomplete'
}));

const mapSaytResults = ({ Results: items }) => items.map((item) => ({
  brand: item.brand,
  image: item.image,
  title: item.title,
  price: item.price,
  reviewScore: item.review_score,
  type: 'sayt',
  url: item.url
}));

class OldHeader extends PureComponent {

  constructor(props) {
    super(props);

    this.menuLinks = menuLinks;

    Object.keys(this.menuLinks).forEach((key) => {
      const link = this.menuLinks[key];

      if (key === 'wishlist' && !settings['component.my-account-menu.is_wishlist_enabled']) {
        delete this.menuLinks[key];
      }

      link.label = translations[link.titleTag];
      link.iconArrow = 'ChevronRight';
    });

    this.handleLinkClick = this.handleLinkClick.bind(this);
    this.handleSearchInput = this.handleSearchInput.bind(this);
    this.clearResultsCache = this.clearResultsCache.bind(this);

    this.state = {
      autocompleteResults: [],
      saytResults: []
    };
  }

  handleLinkClick(link) {
    const event = new CustomEvent('clickDropdownLink');
    event.linkPath = link.path;
    document.dispatchEvent(event);

    if (link.path === menuLinks.signOut.path) {
      removeFromSessionStorage(constants.SESSION_STORAGE_COMPARISON_ITEMS);
      removeFromSessionStorage(constants.SESSION_STORAGE_COMPARISON_BACK_LINK_LABEL);
    }
  }

  handleSearchInput(query) {
    if (query.length <= 0) {
      this.clearResultsCache();
      return;
    }

    autocomplete(query)
      .then((autocompleteResults) => {
        this.setState({
          autocompleteResults: mapAutocompleteResults(autocompleteResults)
        });
      });

    if (query.length > 3) {
      sayt(query)
        .then((saytResults) => {
          this.setState({
            saytResults: mapSaytResults(saytResults)
          });
        });
    } else {
      this.setState({
        saytResults: []
      });
    }
  }

  clearResultsCache() {
    this.setState({
      autocompleteResults: [],
      saytResults: []
    });
  }

  render() {
    const { props, state } = this;

    let accountItem;

    if (props.isLoggedIn) {
      accountItem = {
        render: () => (
          <DropdownMenu
            qa={`account-${props.deviceType}`}
            isAnimated={false}
            key={'my-account-menu'}
            icon={props.menuItems.loggedIn.icon}
            label={replacePlaceholders(translations.menu_welcome, {
              '[NAME]': props.userName
                ? `, ${props.userName.charAt(0).toUpperCase()}.`
                : ''
            })}
            additionalClassName={'dc-header-item dc-header-dropdown'}
            links={this.menuLinks}
            linkClickHandler={this.handleLinkClick}
          />
        )
      };
    } else {
      accountItem = {
        ...props.menuItems.guest,
        key: 'account',
        dataInteraction: 'Main Header: Login'
      };
    }

    return (
      <HeaderComponent
        accountMenuLinks={{}}
        deviceType={props.deviceType}
        desktopLogoSrc={props.desktopLogoSrc}
        desktopLogoSizeFactory={() => props.desktopLogoSize}
        handHeldLogoSizeFactory={() => props.handHeldLogoSize}
        handHeldLogoSrc={props.handHeldLogoSrc}
        homeLink={props.homeLink}
        homeURL={props.homeURL}
        menuItems={[
          {
            ...props.menuItems.menu,
            className: 'dc-header-item--menu',
            key: 'menu'
          },
          {
            ...props.menuItems.search,
            href: '#',
            className: 'dc-header-item--search',
            key: 'search',
            /**
             * @param {MouseEvent} e
             * @param {Header} header
             */
            onClick: (e, header) => {
              e.preventDefault();
              header.cancelClickHandler = true;
              header.toggleSearchExtended(e);
            },
            dataInteraction: 'Main Header: Search Icon'
          },
          {
            ...props.menuItems.stores,
            className: 'dc-header-item--stores',
            key: 'stores',
            dataInteraction: 'Main Header: Store Finder'
          },
          /*
          {
            ...props.menuItems.alerts,
            key: 'alerts',
            badge: { // TODO
              count: props.menuItems.alerts.badgeCount,
              color: '#ee9022'
            }
          },
          */
          accountItem,
          {
            ...props.menuItems.basket,
            badgeCount: props.cartItemsCount,
            key: 'basket',
            badge: {
              contentElementId: 'cart',
              count: props.cartItemsCount,
              color: (itemProps) => (itemProps.badge.count > 0
                ? '#4e8130'
                : '#999'),
              displayZero: true
            },
            dataInteraction: 'Main Header: View Basket'
          }
        ]}
        searchButtonLabel={props.menuItems.search.label}
        searchConfiguration={{
          currency: resolveByCountry('GBP', 'EUR'),
          searchAction: props.searchAction,
          getSuggestions: this.handleSearchInput,
          clearSuggestions: this.clearResultsCache,
          query: props.query,
          suggestions: [
            ...state.autocompleteResults,
            ...state.saytResults
          ]
        }}
      />
    );
  }

}

OldHeader.displayName = 'OldHeader';

const menuItemShape = PropTypes.shape({
  badgeCount: PropTypes.number,
  href: PropTypes.string,
  icon: PropTypes.string,
  label: PropTypes.string
});

OldHeader.propTypes = {
  cartItemsCount: PropTypes.number,
  isTouch: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  deviceType: PropTypes.oneOf(['mobile', 'tablet', 'desktop']),
  desktopLogoSize: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number
  }).isRequired,
  desktopLogoSrc: PropTypes.string.isRequired,
  handHeldLogoSize: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number
  }).isRequired,
  handHeldLogoSrc: PropTypes.string,
  homeLink: PropTypes.string.isRequired,
  homeURL: PropTypes.string.isRequired,
  searchAction: PropTypes.string.isRequired,
  query: PropTypes.string,
  menuItems: PropTypes.shape({
    menu: menuItemShape,
    search: menuItemShape,
    stores: menuItemShape,
    alerts: menuItemShape,
    guest: menuItemShape,
    loggedIn: menuItemShape,
    basket: menuItemShape
  }).isRequired,
  userName: PropTypes.string
};

OldHeader.defaultProps = {
  cartItemsCount: 0,
  deviceType: 'desktop',
  isTouch: false,
  isLoggedIn: false,
  handHeldLogoSrc: undefined,
  query: '',
  userName: undefined
};


function getInitData() {
  const logoEl = document.getElementById('js-header-logo');

  const links = document
    .getElementById('js-header-links')
    .querySelectorAll('.dc-header-item');

  const menuItems = {};
  let loggedIn = false;
  let cartItemsCount = 0;

  Array.prototype.slice.call(links).forEach((link) => {
    const iconEl = link.querySelector('[data-component="Icon"]');
    const labelEl = link.querySelector('.dc-header-item__label');

    if (link.getAttribute('data-item') === 'account') {
      menuItems.loggedIn = {
        href: link.getAttribute('data-logged-in-href'),
        icon: iconEl.getAttribute('data-logged-in-name'),
        label: labelEl.getAttribute('data-logged-in-label')
      };
      menuItems.guest = {
        href: link.getAttribute('data-guest-href'),
        icon: iconEl.getAttribute('data-guest-name'),
        label: labelEl.getAttribute('data-guest-label')
      };
      loggedIn = link.getAttribute('data-logged-in');
    } else {
      menuItems[link.getAttribute('data-item')] = {
        href: link.getAttribute('href'),
        icon: iconEl.getAttribute('data-name'),
        label: labelEl.innerText
      };
      cartItemsCount = parseInt(labelEl.getAttribute('data-badge-count') || 0, 10);
    }
  });

  window.appState.dispatch(
    setCartItemsCount(cartItemsCount)
  );

  const desktopLogoEl = document.getElementById('js-header-logo-desktop');
  const handHeldLogoEl = document.getElementById('js-header-logo-handheld');

  return {
    desktopLogoSize: {
      width: Number(desktopLogoEl.getAttribute('width')),
      height: Number(desktopLogoEl.getAttribute('height'))
    },
    desktopLogoSrc: desktopLogoEl.src,
    handHeldLogoSize: {
      width: Number(handHeldLogoEl.getAttribute('width')),
      height: Number(handHeldLogoEl.getAttribute('height'))
    },
    handHeldLogoSrc: handHeldLogoEl.src,
    homeLink: logoEl.getAttribute('aria-label'),
    homeURL: logoEl.getAttribute('href'),
    query: document.getElementById('search').value,
    searchAction: document.getElementById('searchForm').getAttribute('action'),
    menuItems: menuItems,
    loggedIn: loggedIn
  };
}

function mapStateToProps({ general, userDetails }, ownProps) {
  return {
    deviceType: general.deviceType === 'wide'
      ? 'desktop'
      : general.deviceType,
    isTouch: general.isTouch,
    isLoggedIn: ownProps.loggedIn || (Object.keys(userDetails).length > 0 && !userDetails.isGuest),
    userName: userDetails.first_name,
    cartItemsCount: general.cartItemsCount
  };
}

function init() {
  const root = document.querySelector('[data-component="PageHeader"]');
  if (!root) {
    return;
  }

  const innerHTML = root.innerHTML;

  autocomplete = autocompleteFactory(window.DR.autocompleteSettings.termsURL);
  sayt = saytFactory(window.DR.autocompleteSettings.SAYTURL);

  const ConnectedPageHeader = connect(mapStateToProps)(OldHeader);

  try {
    ReactDOM.render(
      <Provider store={window.appState}>
        <ConnectedPageHeader {...getInitData()} />
      </Provider>,
      root
    );
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
    // Keep old header in case of any error during render
    root.innerHTML = innerHTML;
  }
}

export default {
  component: OldHeader,
  init: init
};
